




































































import { SurveyStatus, SurveyType } from "@/interfaces";
import { AuthModule } from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ManagementHospitality extends Vue {
  @AuthModule.bindings.Getter
  statusBySection!: (section: SurveyType) => SurveyStatus;

  loading = false;

  menu: any = [];

  mounted() {
    this.menu = [
      {
        title: "Analisi",
        subtitle: "",
        children: [
          {
            title: "Mappa Punti informativi",
            to: "/hospitality-infopoint",
          },
          {
            title: "Situazione dell'accoglienza",
            to: this.analysisLink,
          },
        ],
      },
      {
        title: "Strategie",
        subtitle: "",
        to: "/hospitality-strategies",
      },
      {
        title: "Iniziative",
        subtitle: "",
        to: "/hospitality-initiative",
      },
    ];
  }

  onSurveyTypeClick(to: string) {
    this.$router.push(to).catch(error => console.log(error));
  }

  get analysisLink() {
    const find = this.statusBySection(SurveyType.ANALYSIS_HOSPITALITY);

    if (find && find.id) {
      return `survey/${SurveyType.ANALYSIS_HOSPITALITY}/${find.id}`;
    }

    return `survey/${SurveyType.ANALYSIS_HOSPITALITY}`;
  }
}
